
import { RevLink } from '@ds/components/Link'
import { IconChevronDown } from '@ds/icons/IconChevronDown'

import ProgressBar from '@core/components/ProgressBar'
import { MAX_RATING } from '@reviews/constants'
import { trackClick } from '@tracking/events'

import translations from './RatingCategories.translations'

export default {
  components: {
    IconChevronDown,
    ProgressBar,
    RevLink,
  },

  props: {
    categories: {
      type: Array,
      required: true,
    },
    trackingZone: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isCategoriesListDisplayed: false,
    }
  },

  computed: {
    translations: () => translations,
    MAX_RATING: () => MAX_RATING,
    categoryName() {
      return {
        review_main: translations.reviewMain,
        review_accessories: translations.reviewAccessories,
        review_aesthetic_appearance: translations.reviewAestheticAppearance,
        review_battery: translations.reviewBattery,
        review_camera: translations.reviewCamera,
        review_overall_performance: translations.reviewOverallPerformance,
        review_packaging_cleanliness: translations.reviewPackagingCleanliness,
        review_shipping: translations.reviewShipping,
      }
    },
    formattedCategories() {
      return this.categories.map((category) => {
        return {
          ...category,
          percentage: (100 * category.average) / MAX_RATING,
          name: this.categoryName[category.name],
          id: category.name,
        }
      })
    },
    toggleCtaText() {
      return this.isCategoriesListDisplayed
        ? this.$t(translations.showLess)
        : this.$t(translations.showMore)
    },
    accordionIconClass() {
      return this.isCategoriesListDisplayed
        ? 'rotate-180 transition-transform'
        : ''
    },
  },
  methods: {
    toggleCategories() {
      trackClick({
        name: this.isCategoriesListDisplayed
          ? 'see_less_rating_categories'
          : 'see_more_rating_categories',
        zone: this.trackingZone,
      })
      this.isCategoriesListDisplayed = !this.isCategoriesListDisplayed
    },
  },
}
